'use client'

import { useEffect } from 'react';
import { loadGtm } from "@/utils/gtm";
import { loadMatomo } from "@/utils/matomo";
import { setCookie } from '@/utils/cookie'
import { abTestCalculate } from "@/utils/ABtest"
import { useSearchParams, usePathname } from 'next/navigation'
import { matomoSetCustomDimension } from '@/utils/matomoEvent';

export default function Load() {
  const searchParams = useSearchParams()
  const pathname = usePathname()

  useEffect(() => {
    function handleWindowLoad() {
      loadMatomo();
      loadGtm();
      // loadForter();
    }
    
    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  useEffect(() => {
    // 加载AB测试逻辑
    abTestCalculate("2025-07-16_ABTest_Swiper")
  }, []);

  // 路由标记到 body，用于控制特定页面的rating badge显示
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const body = document.body;
    const className = 'hide-rating-badge';
    if (
      pathname === '/account/create-address' 
      || pathname === '/account/edit-address'
      || pathname === '/checkout/express'
      || pathname === '/checkout/paypal-express'
      || pathname === '/checkout/after-pay-express'
      || pathname.includes("/checkout")
    ) {
      body.classList.add(className);
    } else {
      body.classList.remove(className);
    }
  }, [pathname]);

  // 判断是否有aid 或 recoveraid在url，有就将其存贮
  useEffect(() => {
    const aid = searchParams.get('aid')
    const recoveraid = searchParams.get('recoveraid')
    const lastAidValue = aid || ''
    const lastRecoveraidValue = recoveraid || ''

    // 优先于异步请求，将aid存入cookie, 60秒过期（后续会发起请求重新设置）
    if (lastAidValue || lastRecoveraidValue) {
      let currentDomain = window.location.hostname;
      if(currentDomain == 'm.crazysales.com.au') {
        currentDomain = ".crazysales.com.au"
      }
      setCookie('affiliateid', lastAidValue || lastRecoveraidValue, { expires: 30, secure: true, domain: `${currentDomain}`, })
      matomoSetCustomDimension(11, lastAidValue || lastRecoveraidValue)
    }
  }, [searchParams])

  return (
    <div></div>
  );
}
